import { Mixins, Component } from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/course';
import pageMixin from '../../../mixins/pageMixin';

@Component
export default class tableMixin extends Mixins(pageMixin) {
  private cList: any = [];

  private column: Array<ITABLECOLCONF> = [{
    label: '名称',
    prop: 'courseTitle',
    align: 'center',
    minWidth: '100px',
    tooltip: true,
  }, {
    label: '版本号',
    prop: 'courseVersion',
    align: 'center',
    tooltip: true,
    minWidth: '70px',
  }, {
    label: '课程图标',
    prop: 'courseIco',
    align: 'center',
    custom: true,
    icon: true,
    width: '80px',
  }, {
    label: '状态',
    prop: 'courseStatus',
    custom: true,
    align: 'center',
    width: '100px',
    tags: [{
      value: '0',
      type: 'warning',
      label: '禁用',
    }, {
      value: '1',
      type: 'success',
      label: '启用',
    }],
  }, {
    label: '课程长图',
    prop: 'courseImage',
    align: 'center',
    custom: true,
    cover: true,
    width: '80px',
  }, {
    label: '课时(小时)',
    prop: 'classHours',
    align: 'center',
    width: '60px',
  }, {
    label: '章节数',
    prop: 'stepTotal',
    align: 'center',
    width: '60px',
  }, {
    label: '课时基数',
    prop: 'standardNumber',
    align: 'center',
    width: '70px',
  }, {
    label: '分类',
    prop: 'typePath',
    align: 'center',
  }, {
    label: '简介',
    prop: 'courseDesc',
    align: 'center',
    tooltip: true,
  }, {
    label: '创建时间',
    prop: 'createTime',
    align: 'center',
    minWidth: '100px',
    tooltip: true,
  }, {
    label: '操作',
    custom: true,
    minWidth: '120',
    align: 'center',
    maxBtn: 1,
    btnList: [
      {
        title: '操作',
        name: '/course/info:chapter',
        icon: 'edit',
        type: 'info',
        callback: this.handleChapter,
        log: {
          name: '课程信息 - 操作',
          component: 'course/info/tableMixin',
        },
      },
      {
        title: '修改',
        name: '/course/info:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleEdit,
        log: {
          name: '课程信息 - 修改',
          component: '/course/info:update',
        },
      },
      {
        title: '修改内容',
        name: '/course/info:updateContent',
        icon: 'edit',
        type: 'info',
        callback: this.handleEditContent,
        log: {
          name: '课程信息 - 修改',
          component: '/course/info:update',
        },
      },
      {
        title: '删除',
        name: '/course/info:remove',
        icon: 'trash-o',
        type: 'info',
        callback: this.handleRemove,
        log: {
          name: '课程信息 - 删除',
          component: '/course/info:update',
        },
      },
      {
        title: '复制课包',
        name: '/course/info:copy',
        icon: 'edit',
        type: 'info',
        callback: this.handleCopy,
        log: {
          name: '课程信息 - 删除',
          component: '/course/info:update',
        },
      },
    ],
  }]

  private loading: boolean = false;

  mounted() {
    this.getData();
  }

  /**
   * @author liangyongmou
   * @desc 获取课程信息列表
   */
  getData(params?: any) {
    this.loading = true;
    this.page.params = params;
    const data = { pageSize: this.page.pageSize, pageNo: this.page.pageNo, ...this.page.params };
    api.getCList(data).then((res: any) => {
      this.cList = res.content;
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  /**
   * @author liangyongmou
   * @desc 打开课程章节
   * @param { any } row 行数据
   */
  handleChapter(row: any) {
    this.$router.push({ name: 'course/chapter', params: { pid: Base64.encode(row.pid), type: 'Resource' } });
  }

  /* eslint-disable class-methods-use-this */
  handleEdit(row: any) {}

  /* eslint-disable class-methods-use-this */
  handleEditContent(row: any) {}

  /**
   * @author liangyongmou
   * @desc 删除正式课事件
   * @params { any } row 行数据
   */
  handleRemove(row: any) {
    this.confirm('你确定要删除该正式课吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeCourse(row.pid).then(() => {
        this.getData();
        close();
        this.$log({
          title: '正式课管理 - 删除 - 确定',
          component: 'trial/manage/bModal',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '正式课管理 - 删除 - 取消',
      component: 'trial/manage/bModal',
    }));
  }

  handleCopy(row: any) {
    const data = new FormData();
    data.append('cid', row.pid);
    api.copyCourse(data).then((res: any) => {
      this.getData();
    });
  }
}
